export default __webpack_public_path__ + "static/media/grapes.9e3f4fd8.jpg";